
import { useIGAO } from '../context'

import { Other, Multi, NotIgao, Static, CarePlan, Single, Header } from './items'

const isMultiItem = item =>
  item?.relations?.length > 1 ||
  item?.relations?.filter(rel => rel.type === 'input').length > 0

export function RenderItems ({
  handleChecked,
  handleCheckbox,
  handleInputSubmit,
  handleBatch,
  selectedIssueId,
  setSelectedIssueId,
  handleInput,
  createDescription,
  handleChangeResponse
}) {
  const { pageData: { items } } = useIGAO()
  const filteredItems = items?.filter(i => !i?.hidden)
  const staticTypes = [ 'label', 'header' ]
  const renderItem = (item, k) => {
    if (item.type === 'other') {
      return (
        <Other
          key={item.id}
          item={item}
          prevItem={filteredItems[k - 1]}
          handleInputSubmit={handleInputSubmit}
          handleBatch={handleBatch}
          selectedIssueId={selectedIssueId}
          setSelectedIssueId={setSelectedIssueId}
        />
      )
    }

    if (item.type === 'careplan') {
      return (
        <CarePlan
          key={item.id}
          item={item}
          prevItem={filteredItems[k - 1]}
          handleInputSubmit={handleInputSubmit}
          handleBatch={handleBatch}
          selectedIssueId={selectedIssueId}
          setSelectedIssueId={setSelectedIssueId}
        />
      )
    }

    if (staticTypes.includes(item.type)) {
      return (
        <Header
          item={item}
          key={item.id}
          prevItem={filteredItems[k - 1]}
        />
      )
    }

    if (item.type === 'plain') {
      return (
        <NotIgao
          prevItem={filteredItems[k - 1]}
          key={item.id}
          item={item}
          handleChangeResponse={handleChangeResponse}
        />
      )
    }

    if (isMultiItem(item)) {
      return (
        <Multi
          key={item.id}
          item={item}
          prevItem={filteredItems[k - 1]}
          handleCheckbox={handleCheckbox}
          handleInputSubmit={handleInputSubmit}
          handleInput={handleInput}
          createDescription={createDescription}
          handleBatch={handleBatch}
          selectedIssueId={selectedIssueId}
          setSelectedIssueId={setSelectedIssueId}
        />
      )
    }

    if (item.type === 'static') {
      return (
        <Static
          key={item.id + item?.answer}
          item={item}
          prevItem={filteredItems[k - 1]}
          selectedIssueId={selectedIssueId}
          setSelectedIssueId={setSelectedIssueId}
          handleBatch={handleBatch}
          handleInputSubmit={handleInputSubmit}
        />
      )
    }

    if (item?.relations?.length === 1) {
      return (
        <Single
          item={item}
          handleChecked={handleChecked}
          key={item.id}
          prevItem={filteredItems[k - 1]}
          handleCheckbox={handleCheckbox}
          handleBatch={handleBatch}
          handleInputSubmit={handleInputSubmit}
          selectedIssueId={selectedIssueId}
          setSelectedIssueId={setSelectedIssueId}
        />
      )
    }

    return null
  }

  return filteredItems?.map((item, k) => renderItem(item, k))
}
